import { getStore } from "store";
import { setProductReferenceSource, clearProductReferenceSource } from "actions/item";
import _ from "lodash";

export default function (nextState, replace) {
    const { location } = nextState;
    const store = getStore();
    const state = store.getState();
    if (location.query?.orderType) {
        if (location.query.orderType && !state.item.referenceSource) {
            store.dispatch(setProductReferenceSource(location.query?.orderType));
        } else if (
            location.query.orderType &&
            state.item.referenceSource &&
            state.item.current &&
            state.item.current._id !== nextState.params.item
        ) {
            store.dispatch(clearProductReferenceSource());
            const sanitizedQuery = _.omit(location.query, ["orderType"]);
            replace({
                pathname: location.pathname,
                query: sanitizedQuery,
            });
        }
    } else if (!location.query?.orderType && state.item.referenceSource) {
        store.dispatch(clearProductReferenceSource());
    }
}
